import OpenPhoneProtocolHandler from './OpenPhoneProtocolHandler'

export const PROTOCOL = 'web+openphone'

export default class WebOpenPhoneProtocolHandler extends OpenPhoneProtocolHandler {
  override readonly protocol = PROTOCOL
  override readonly web = true
  override readonly desktop = false
}
